"use client";

import { useState, useEffect } from "react";
import { PencilLine } from "lucide-react";

import { Button } from "@/components/ui/button";
import { acmeLogoIcon } from "@/lib/Images";
import ChangeBrandColorsDialog from "@/components/dialogs/tenants/branding/ChangeBrandColorsDialog";
import ChangeBrandLogoDialog from "@/components/dialogs/tenants/branding/ChangeBrandLogoDialog";
import { setPrimaryColor } from "@/store/slices";
import { useDispatch } from "react-redux";

const BrandingTab = ({ organisationDetails }) => {
  const dispatch = useDispatch();
  const tenantId = organisationDetails?._id;
  const [openBrandColors, setOpenBrandColors] = useState(false);
  const [openBrandLogo, setOpenBrandLogo] = useState(false);
  const [brandingData, setBrandingData] = useState({
    logo: organisationDetails?.branding?.logoUrl || null,
    updatedAt: organisationDetails?.updatedAt,
    logoName: organisationDetails?.branding?.logoUrl?.split("/").pop() || "",
    // primaryColor: organisationDetails?.branding?.primaryColor || "#6366F1",
    // secondaryColor: organisationDetails?.branding?.secondaryColor || "#84CC16",
    primaryColor: organisationDetails?.branding?.primaryColor || "",
    secondaryColor: organisationDetails?.branding?.secondaryColor || "",
  });

  const hasLogo = !!brandingData?.logo;
  const hasBrandColor =
    !!organisationDetails?.branding?.primaryColor ||
    !!organisationDetails?.branding?.secondaryColor;
  const handleChangeLogo = () => {
    // console.log("Change logo clicked");
    setOpenBrandLogo(true);
  };
  useEffect(() => {
    if (organisationDetails) {
      setBrandingData({
        logo: organisationDetails?.branding?.logoUrl || null,
        updatedAt: organisationDetails?.updatedAt,
        logoName:
          organisationDetails?.branding?.logoUrl?.split("/").pop() || "",
        primaryColor: organisationDetails?.branding?.primaryColor || "",
        secondaryColor: organisationDetails?.branding?.secondaryColor || "",
      });
    }
  }, [organisationDetails]);
  return (
    <section className="mt-8">
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <div>
          <h2 className="mb-3 text-sm font-semibold text-neutral-100/80">
            Logo
          </h2>

          <div className="overflow-hidden rounded-md bg-[#151515]">
            {/* <div className="min-h-[150px] px-10 py-8">
              <div className="flex flex-col items-start">
                <img
                  src={`${brandingData?.logo || acmeLogoIcon}?v=${brandingData?.updatedAt}`}
                  alt="Acme logo"
                  className="h-[95px] w-[95px] object-contain bg-white"
                />

                <p className="mt-3 text-xs font-medium text-neutral-100">
                  {brandingData.logoName}
                </p>
              </div>
            </div> */}
            <div className="min-h-[185px] px-10 py-8">
              {hasLogo ? (
                <div className="flex flex-col items-start">
                  <img
                    src={`${brandingData.logo}?v=${brandingData?.updatedAt}`}
                    alt="Tenant logo"
                    className="h-[95px] w-[95px] object-contain bg-white"
                  />

                  <p className="mt-3 text-xs font-medium text-neutral-100">
                    {brandingData.logoName}
                  </p>
                </div>
              ) : (
                <div className="flex min-h-[121px] items-center justify-center text-center">
                  <p className="max-w-[360px] text-sm font-bold text-neutral-100">
                    Upload tenant logo to personalize their brand identity
                    across all experiences.
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end bg-[#3B3B4D] px-5 py-4">
              {/* <Button
                type="button"
                onClick={handleChangeLogo}
                className="h-8 rounded-md bg-brand-21 px-5 text-xs font-bold text-neutral-100 hover:bg-brand-22"
              >
                <PencilLine className="mr-2 h-3.5 w-3.5" />
                Change Logo
              </Button> */}
              <Button
                type="button"
                onClick={handleChangeLogo}
                className="h-8 rounded-md bg-brand-21 px-5 text-xs font-bold text-neutral-100 hover:bg-brand-22"
              >
                {hasLogo && <PencilLine className="mr-2 h-3.5 w-3.5" />}

                {hasLogo ? "Change Logo" : "Upload Logo"}
                {/* <PencilLine className="mr-2 h-3.5 w-3.5" />
                {hasLogo ? "Change Logo" : "Upload Logo"} */}
              </Button>
            </div>
          </div>
        </div>

        <div>
          <h2 className="mb-3 text-sm font-semibold text-neutral-100/80">
            Brand Colors
          </h2>

          <div className="overflow-hidden rounded-md bg-[#151515]">
            {/* <div className="min-h-[185px] px-10 py-9">
              <div className="space-y-7">
                <BrandColorRow
                  color={brandingData.primaryColor}
                  label={`Primary Color ${brandingData.primaryColor}`}
                /> */}

            {/* <BrandColorRow
                  color={brandingData.secondaryColor}
                  label={`Secondary Color ${brandingData.secondaryColor}`}
                /> */}
            {/* </div>
            </div> */}

            <div className="min-h-[185px] px-10 py-9">
              {hasBrandColor ? (
                <div className="space-y-7">
                  <BrandColorRow
                    color={brandingData.primaryColor}
                    label={`Primary Color ${brandingData.primaryColor}`}
                  />
                </div>
              ) : (
                <div className="flex h-full items-center justify-center text-center">
                  <p className="max-w-[360px] text-sm font-bold text-neutral-100">
                    Add brand colors to maintain a consistent look and feel
                    across the experiences.
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end bg-[#3B3B4D] px-5 py-4">
              {/* <Button
                type="button"
                onClick={() => setOpenBrandColors(true)}
                className="h-8 rounded-md bg-brand-21 px-5 text-xs font-bold text-neutral-100 hover:bg-brand-22"
              >
                <PencilLine className="mr-2 h-3.5 w-3.5" />
                Change Brand Colors
              </Button> */}
              <Button
                type="button"
                onClick={() => setOpenBrandColors(true)}
                className="h-8 rounded-md bg-brand-21 px-5 text-xs font-bold text-neutral-100 hover:bg-brand-22"
              >
                <PencilLine className="mr-2 h-3.5 w-3.5" />
                {hasBrandColor ? "Change Brand Colors" : "Add Brand Colors"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ChangeBrandColorsDialog
        open={openBrandColors}
        onClose={() => setOpenBrandColors(false)}
        tenantId={tenantId}
        primaryColor={brandingData.primaryColor}
        secondaryColor={brandingData.secondaryColor}
        // onSuccess={(payload) => {
        //   setBrandingData((prev) => ({
        //     ...prev,
        //     primaryColor: payload.primaryColor,
        //     secondaryColor: payload.secondaryColor,
        //   }));
        // }}
        onSuccess={(payload) => {
          setBrandingData((prev) => ({
            ...prev,
            primaryColor: payload.primaryColor,
            secondaryColor: payload.secondaryColor,
          }));

          dispatch(
            setPrimaryColor({
              tenantId,
              color: payload.primaryColor,
            }),
          );
        }}
      />

      <ChangeBrandLogoDialog
        open={openBrandLogo}
        onClose={() => setOpenBrandLogo(false)}
        tenantId={tenantId}
        organisationDetails={organisationDetails}
        currentLogo={brandingData.logo}
        onSuccess={(payload) => {
          setBrandingData((prev) => ({
            ...prev,
            logo: payload.logoUrl,
            logoName: payload.logoUrl?.split("/").pop() || prev.logoName,
          }));
        }}
      />
    </section>
  );
};

const BrandColorRow = ({ color, label }) => {
  return (
    <div className="flex items-center gap-5">
      <span
        className="h-8 w-8 rounded-full border-2 border-white"
        style={{ backgroundColor: color }}
      />

      <span className="text-sm font-bold text-neutral-100">{label}</span>
    </div>
  );
};

export default BrandingTab;
